module.exports = __webpack_public_path__ + "img/configureBlue.deb0e772.svg";